export const TOAST_ANIMATION_TIME = 300;

export const ToastType = {
  NEUTRAL: 'neutral',
  POSITIVE: 'positive',
  NEGATIVE: 'negative',
};
